

/*
  All methods(pushToast, success, error, etc...)) accept a "confirm" object, which describes a confirmation modal. Toasts with "confirm" don't have timeouts.

  interface Confirm {
    confirmMessage?: string | "Confirm";
    cancelMessage?: string | "Cancel";
    description?: string;

    onConfirm: Function; // Can be async.
    onCancel?: Function; // Can be async.
  }
*/

export default {
  namespaced: true,

  state: () => ({
    toast: null,
    toastTimeout: null,
    loading: false,
  }),
  getters: {
    type(state) {
      return state.toast && state.toast.type
    },
    message(state) {
      return state.toast && state.toast.message
    },
    description(state) {
      return state.toast && state.toast.description
    },
    confirm(state) {
      return state.toast && state.toast.confirm
    },
    confirmMessage(state) {
      return state.toast && state.toast.confirm && state.toast.confirm.confirmMessage
    },
    cancelMessage(state) {
      return state.toast && state.toast.confirm && state.toast.confirm.cancelMessage
    },

    toast(state) {
      return state.toast
    },
  },
  actions: {
    async push({ state, dispatch }, {toast, timeout}) {
      if (!timeout) timeout = 3000
      if (state.toastTimeout) {
        clearTimeout(state.toastTimeout)
        dispatch("close")
      }

      if (!toast.type) toast.type = "success"
      state.toast = toast

      if (!toast.confirm) {
        state.toastTimeout = setTimeout(() => dispatch("close"), timeout)
      }
    },
    async success({ dispatch }, {message, config, ...obj}) {
      dispatch("push", { toast: { message, type: "success", ...obj }, ...config})
    },
    async warning({ dispatch }, {message, config, ...obj}) {
      dispatch("push", { toast: { message, type: "warning", ...obj }, ...config})
    },
    async error({ dispatch }, {message, config, ...obj}) {
      dispatch("push", { toast: { message, type: "error", ...obj }, ...config})
    },
    async info({ dispatch }, {message, config, ...obj}) {
      dispatch("push", { toast: { message, type: "info", ...obj }, ...config})
    },
    async close({ state }) {
      state.toast = null
    },

    async handleAsyncCallback({ dispatch, state }, callback) {
      if (!callback) return dispatch("close")

      state.loading = true
      let toast
      try {
        toast = await callback()
      } catch (err) {
        console.error(err)
        toast = {
          message: "There was an error when doing you request",
          type: "error",
        }
      } finally {
        state.loading = false
      }

      dispatch("close")
      if (toast) {
        setTimeout(() => dispatch("push", {toast}), 160)
      }
    },
    async handleError({ dispatch }, err) {
      console.error(err)

      let message
      if (err && err.response && err.response.data) {
        if (err.response.data.errors) {
          message = err.response.data.errors[0]
        } else if (err.response.data[0] && err.response.data[0].message) {
          message = err.response.data[0].message
        } else if (err.response.statusText) {
          message = err.response.statusText
        }
      }

      if (!message) message = err
      dispatch("error", { message })
    },
    async onSave({ dispatch, state }) {
      await dispatch('handleAsyncCallback', state.toast && state.toast.confirm && state.toast.confirm.onConfirm)
    },
    async onCancel({ dispatch, state }) {
      await dispatch('handleAsyncCallback', state.toast && state.toast.confirm && state.toast.confirm.onCancel)
    },
  },
}

